<div
    class="avatar avatar-{{ size }}"
    [class.bg-icon]="!avatar?.prioritiseIcon"
    [ngClass]="borderClasses"
    [attr.data-cy]="'avatar-' + avatar?.text"
    [style.backgroundColor]="
        !avatar?.isUnknown && !avatar?.icon && !avatar?.avatarUrl
            ? (avatar?.text | textToHsl)
            : null
    "
    [class.bg-danger]="avatar?.isUnknown"
    [class.text-danger-contrast]="avatar?.isUnknown"
    [class.text-body]="
        (!avatar?.isUnknown && avatar?.text) || !avatar?.prioritiseIcon
    "
>
    @if (!avatar?.prioritiseIcon && avatar?.text && !avatar?.isUnknown) {
        <span class="avatar-alt-initials">{{ initials }}</span>
    } @else {
        <wdx-icon-container [size]="size!">
            <wdx-icon
                class="avatar-alt-icon"
                [class.text-gray-500]="!avatar?.isUnknown"
                [icon]="altIcon"
            ></wdx-icon>
        </wdx-icon-container>
    }

    <ng-template #altText>
        <span class="avatar-alt-text">{{ avatar?.text }}</span>
    </ng-template>

    <div
        class="avatar-image"
        [style.background-image]="
            avatar?.avatarUrl ? 'url(' + avatar?.avatarUrl + ')' : ''
        "
    ></div>
</div>
